import type {LoaderFunctionArgs} from 'react-router'
import {redirect, useLoaderData} from 'react-router-dom'

import Context from '@s-ui/react-context'

import {getNavigationState} from '../../../helpers/navigationStateCache.ts'
import {withThirdPartiesParam} from '../../../hocs/withThirdPartiesParam.js'
import {getInitialProps} from './getInitialProps'
import TechnicalDetailsMakeComponentRaw from './index.js'

// Import styles
import './styles/index.scss'
// HOC wrapping that used to live in `./index.js`. Moved here so `./index.js`
// exports the raw component and receives Fast Refresh in dev.
const TechnicalDetailsMakeComponent = withThirdPartiesParam(Context.wrapper(TechnicalDetailsMakeComponentRaw))

export async function loader({context, request, params}: LoaderFunctionArgs) {
  const url = new URL(request.url)
  const pathname = url.pathname
  const query = Object.fromEntries(url.searchParams.entries())

  // Build routeInfo compatible with getInitialProps
  const routeInfo = {
    location: {
      pathname,
      query,
      search: url.search,
      state: getNavigationState(pathname)
    },
    params: {
      make: params.make
    }
  }

  // Call existing getInitialProps
  const data = await getInitialProps({routeInfo, context})

  const redirectTo: unknown = data?.__HTTP__?.redirectTo
  if (typeof redirectTo === 'string' && redirectTo !== '') {
    return redirect(redirectTo)
  }

  return data
}

export function Component() {
  const data = useLoaderData()
  return <TechnicalDetailsMakeComponent {...data} />
}
